// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import components from './components'
import VueWechatTitle from 'vue-wechat-title'
import axios from 'axios'
import func from './function.js'

Vue.prototype.$http = axios //将axios挂载到vue实例中的ajax上，在项目中可以使用this.$http调用

Vue.use(func)
Vue.use(components)
Vue.use(VueWechatTitle)
Vue.config.productionTip = false

/* eslint-disable no-new */


  new Vue({
    el: '#app',
    router,
    components: {App},
    template: '<App/>',
  })



// WEBPACK FOOTER //
// ./src/main.js